var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"share"},[_c('a',{staticClass:"fa fa-facebook",attrs:{"href":"#"},on:{"click":_vm.shareToFacebook}},[_vm._v("Share")]),_c('a',{staticClass:"fa fa-instagram",attrs:{"href":"#"},on:{"click":_vm.shareToInstagram}})])}
var staticRenderFns = []

export { render, staticRenderFns }